// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Dropdown{display:none;position:relative;z-index:500}.Dropdown--open{display:block}.Dropdown--fullWidth{width:100%}.Dropdown__hideIcon{color:#d9d9d9;cursor:pointer;line-height:1;position:absolute;right:.5em;top:.5em}@media(max-width:767.98px){.Dropdown--mobileSlideDown{position:relative!important;transform:none!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
